'use client'

import type { PropsWithChildren } from 'react'

export const SectionHeaderMain = ({ children }: PropsWithChildren) => {
  return <div className="flex flex-col gap-1">{children}</div>
}
